import axios from 'axios';
import { toast } from 'react-toastify';
import store from '../../../app/store/store';
import { incrementLoading, decrementLoading } from '../../../app/store/slices/loadingSlice';

//const API_URL = 'http://localhost:5199/api/';
const API_URL = 'https://dev-billeur-api-webapp-f3cnbwfybmhdbjap.westeurope-01.azurewebsites.net/api/';

const authAxios = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,  // ✅ Always send/receive cookies
  timeout: 30000, // ✅ Increased to 30 seconds to handle slow network connections
});

authAxios.interceptors.request.use(
  (config) => {
    // ✅ Increment global loading counter
    store.dispatch(incrementLoading());
    return config;
  },
  (error) => {
    // ✅ Decrement loading counter on error
    store.dispatch(decrementLoading());
    toast.error('Failed to send authentication request');
    return Promise.reject(error);
  }
);

authAxios.interceptors.response.use(
  (response) => {
    // ✅ Decrement global loading counter on success
    store.dispatch(decrementLoading());
    return response;
  },
  (error) => {
    // ✅ Decrement global loading counter on error
    store.dispatch(decrementLoading());
    
    // Handle network errors only (auth failures are handled by components)
    if (!error.response && error.request) {
      if (!toast.isActive('network-error')) {
        toast.error('Something went wrong. Please try again later.', { toastId: 'network-error' });
      }
    } else if (!error.response && !error.request) {
      if (!toast.isActive('request-error')) {
        toast.error('An unexpected error occurred.', { toastId: 'request-error' });
      }
    } else {
      // Log API errors but let components handle them
    }
    
    return Promise.reject(error);
  }
);

export default authAxios;